import { twMerge } from 'tailwind-merge';

type SkeletonBoxProps = {
	className?: string;
};

const SkeletonBox = ({ className }: SkeletonBoxProps) => {
	return (
		<div
			className={twMerge(
				'animate-pulse rounded bg-mantang-gray-100',
				className,
			)}
		/>
	);
};

export default SkeletonBox;
